var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-h-screen bg-gray-50", attrs: { id: "app" } },
    [
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c(
          "header",
          { staticClass: "bg-white shadow-sm", attrs: { id: "header" } },
          [
            _c("div", { staticClass: "container mx-auto px-4 py-4" }, [
              _c("div", { staticClass: "flex items-center justify-between" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center space-x-4 w-full" },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "text-sm font-medium text-gray-700 whitespace-nowrap"
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.activeFolder.name) + " / Regla: "
                        )
                      ]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ruleState.name,
                          expression: "ruleState.name"
                        }
                      ],
                      staticClass:
                        "flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2",
                      attrs: {
                        type: "text",
                        placeholder: "Ingrese el nombre de la regla"
                      },
                      domProps: { value: _vm.ruleState.name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.ruleState, "name", $event.target.value)
                        }
                      }
                    }),
                    _c(
                      "span",
                      {
                        staticClass:
                          "text-sm font-medium text-gray-700 whitespace-nowrap"
                      },
                      [_vm._v(" Prioridad: ")]
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ruleState.priority,
                          expression: "ruleState.priority"
                        }
                      ],
                      staticClass:
                        "flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2",
                      attrs: {
                        type: "text",
                        placeholder: "Ingrese el nombre de la regla",
                        min: "0",
                        max: "100"
                      },
                      domProps: { value: _vm.ruleState.priority },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.ruleState,
                            "priority",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ]
                )
              ])
            ])
          ]
        ),
        _c("main", { staticClass: "container mx-auto px-4 py-8" }, [
          _c(
            "div",
            {
              staticClass: "bg-white rounded-xl shadow-sm p-6",
              attrs: { id: "rule-builder" }
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center justify-between mb-4" },
                [
                  _c("h2", { staticClass: "text-lg font-medium" }, [
                    _vm._v("Condiciones")
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "space-y-6",
                  attrs: { id: "conditions-builder" }
                },
                _vm._l(_vm.ruleState.conditions, function(condition, index) {
                  return _c("ConditionRenderer", {
                    key: index,
                    attrs: {
                      index: index,
                      condition: condition,
                      jsonPathTypes: _vm.jsonPathTypes
                    }
                  })
                }),
                1
              )
            ]
          )
        ]),
        _c("main", { staticClass: "container mx-auto px-4 py-8" }, [
          _c(
            "div",
            {
              staticClass: "bg-white rounded-xl shadow-sm p-6",
              attrs: { id: "rule-builder" }
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center justify-between mb-4" },
                [
                  _c("h2", { staticClass: "text-lg font-medium" }, [
                    _vm._v("Condiciones internas")
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "space-y-6", attrs: { id: "metadata-builder" } },
                [
                  _c("MetadataForm", {
                    attrs: { ruleState: _vm.ruleState },
                    on: {
                      saveMeta: function($event) {
                        return _vm.saveMeta($event)
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _c("main", { staticClass: "container mx-auto px-4 py-8" }, [
          _c(
            "div",
            {
              staticClass: "bg-white rounded-xl shadow-sm p-6",
              attrs: { id: "rule-builder" }
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center justify-between mb-4" },
                [
                  _c("h2", { staticClass: "text-lg font-medium" }, [
                    _vm._v("Acciones")
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "actions-container" },
                [
                  _vm._l(_vm.ruleState.actions, function(condition, index) {
                    return _c("ActionForm", {
                      key: index,
                      attrs: { index: index, actiondata: condition },
                      on: {
                        removeAction: function($event) {
                          return _vm.removeAction(index)
                        }
                      }
                    })
                  }),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover",
                          value: "Agregar nueva acción",
                          expression: "'Agregar nueva acción'",
                          modifiers: { hover: true }
                        }
                      ],
                      staticClass: "btn-icon mt-2 text-center shadow",
                      attrs: {
                        title: "Agregar nueva acción",
                        size: "sm",
                        variant: "outline-primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.addAction()
                        }
                      }
                    },
                    [_c("feather-icon", { attrs: { icon: "PlusIcon" } })],
                    1
                  )
                ],
                2
              ),
              _c(
                "div",
                {
                  staticClass: "bg-white rounded-xl shadow-sm p-6",
                  attrs: { id: "rule-builder" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "mt-8 flex justify-end space-x-4",
                      attrs: { id: "form-actions" }
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { variant: "success" },
                          on: {
                            click: function($event) {
                              return _vm.saveRule()
                            }
                          }
                        },
                        [_vm._v(" Guardar ")]
                      )
                    ],
                    1
                  )
                ]
              )
            ]
          )
        ]),
        _vm.isSuperAdmin
          ? _c(
              "main",
              { staticClass: "container mx-auto px-4 py-8" },
              [
                _c(
                  "app-collapse-item",
                  {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "header",
                          fn: function(props) {
                            return [
                              _c("feather-icon", {
                                staticClass: "mr-1 icon-header",
                                attrs: {
                                  icon: !props.visible
                                    ? "ChevronUpIcon"
                                    : "ChevronDownIcon",
                                  size: "18"
                                }
                              }),
                              _c(
                                "span",
                                { staticClass: "lead collapse-title" },
                                [_vm._v("Regla como JSON")]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3201712760
                    )
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: " bg-white rounded-xl shadow-sm p-6",
                        attrs: { id: "preview-section" }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "bg-gray-900 rounded-lg p-4" },
                          [
                            _c(
                              "pre",
                              {
                                staticClass:
                                  "text-green-400 text-sm overflow-x-auto"
                              },
                              [_vm._v(_vm._s(_vm.jsonRule))]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }